import XyberClanWebsite from './xybersite';

function App() {
  return <XyberClanWebsite />;
}

export default App;